import React, { ReactNode } from 'react';
import { Command } from 'cmdk';
import { MultiSelectStore } from './multi-select.store';

type OnChangeFn = (v: string) => void;

type MultiSelectProps = Pick<
  React.ComponentProps<typeof Command>,
  'filter' | 'children' | 'shouldFilter'
> & {};

const MultiSelectContext = React.createContext<MultiSelectStore | undefined>(undefined);

export const MultiSelectProvider = ({ children }: MultiSelectProps) => {
  const [store] = React.useState<MultiSelectStore>(() => new MultiSelectStore());
  return (
    <MultiSelectContext.Provider
      value={store}
    >
      {children}
    </MultiSelectContext.Provider>
  );
};

export const useMultiSelect = () => {
  const ctx = React.useContext(MultiSelectContext);
  if (!ctx) {
    throw new Error('useMultiSelect must be used inside MultiSelectProvider');
  }
  return ctx;
};
